export default __webpack_public_path__ + "static/media/successware.a5bfce7d.png";